/**
 * FAQ content registry, keyed by userType (the :userType route param). Mirrors
 * LegalPage/content/index.js. FaqPage looks up the blocks by param and 404s an unknown key.
 */
import parent from './parent';
import provider from './provider';

export const FAQ_CONTENT = { parent, provider };

// The page title per audience (the page's H1; the content files hold only the Q&A blocks).
export const FAQ_TITLES = {
  parent: 'FAQ — For Parents',
  provider: 'FAQ — For Providers',
};

// Version + effective date per FAQ, shown as a revision line under the title (client ask: "include
// the version and published date, like the other pages"). From the client's v1.0 documents.
export const FAQ_META = {
  parent: { version: '1.2', effectiveDate: 'July 29, 2026' },
  provider: { version: '1.2', effectiveDate: 'July 29, 2026' },
};
